// src/mapcomponents/GpxRoute.js
import { useMemo } from 'react';
import { Polyline } from 'react-leaflet';
import { findNearestRouteIndex } from '../helpers/gpxHelper';
import { useData } from '../contexts/DataContext';


export default function GpxRoute() {
  const { gpxPoints: routePoints, latest: currentTrackpoint } = useData();

 
  const nearestIndex = useMemo(() => {
    if (!routePoints?.length || !currentTrackpoint) return -1;
    return findNearestRouteIndex(routePoints, currentTrackpoint);
  }, [routePoints, currentTrackpoint]);

  const orangeSegment = useMemo(() => {
    if (nearestIndex === -1) return [];
    return routePoints.slice(0, nearestIndex + 1);
  }, [routePoints, nearestIndex]);

  const blueSegment = useMemo(() => {
    if (nearestIndex === -1) return [];
    return routePoints.slice(nearestIndex);
  }, [routePoints, nearestIndex]);

  if (nearestIndex === -1) return null;

  return (
    <>
      <Polyline positions={orangeSegment} color="orange" weight={4} />
      <Polyline positions={blueSegment} color="blue" weight={3} opacity={0.4} />
    </>
  );
}
